import { weeklyHot } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

const tagColor: Record<string, string> = {
  剧集: 'bg-primary-100 text-primary-800',
  人物: 'bg-accent-100 text-accent-900',
  红毯: 'bg-secondary-100 text-secondary-800',
  综艺: 'bg-accent-100 text-accent-900',
  组合: 'bg-primary-100 text-primary-800',
  官宣: 'bg-secondary-100 text-secondary-800',
};

export default function WeeklyHot() {
  return (
    <section id="weekly" className="relative scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHead
            eyebrow="本周热门事件汇总"
            title="本周吃瓜热榜"
            desc="以讨论声量与发酵时长综合排序。以下事件均为公开话题的盘点整理，不代表本站立场，亦不对当事人作定论。"
          />
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line" aria-hidden="true"></i>
              更新于
            </span>
            <span className="rounded-md bg-background-100 px-2.5 py-1 font-semibold text-foreground-700">本周一</span>
          </div>
        </div>

        <div className="mt-10 flex flex-col">
          {weeklyHot.map((item, i) => {
            const top3 = i < 3;
            return (
              <article
                key={item.title}
                className={`group grid grid-cols-1 gap-4 border-b border-background-200 py-6 transition-colors last:border-none md:grid-cols-[80px_1fr_auto] md:items-center md:gap-6 ${
                  i === 0 ? 'border-t' : ''
                }`}
              >
                {/* 排名 */}
                <div className="flex items-center gap-3 md:block">
                  <span
                    className={`big-rank text-4xl leading-none tracking-tight md:text-5xl ${
                      top3 ? 'text-primary-500' : 'text-background-300'
                    }`}
                  >
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                {/* 正文 */}
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded-md px-2 py-0.5 text-xs font-bold ${
                        tagColor[item.tag] ?? 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">#{item.word}</span>
                  </div>
                  <h3 className="mt-2 text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 max-w-3xl text-sm text-foreground-600">{item.summary}</p>
                </div>

                {/* 热度 */}
                <div className="flex items-center gap-4 md:w-44 md:justify-end md:text-right">
                  <div className="w-full md:w-28">
                    <div className="flex items-baseline justify-between md:justify-end md:gap-2">
                      <span className="text-xs text-foreground-500">热度</span>
                      <span className="font-latin-display text-lg text-foreground-900">{item.heat}</span>
                    </div>
                    <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${top3 ? 'bg-primary-500' : 'bg-accent-500'}`}
                        style={{ width: `${item.heat}%` }}
                      />
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-xl bg-background-100 p-5 sm:flex-row sm:items-center">
          <p className="text-sm text-foreground-600">
            <i className="ri-information-line mr-1.5 text-primary-500" aria-hidden="true"></i>
            完整榜单与逐条讨论请在评论区聊，我们每期精选神回复放进下周加更。
          </p>
          <a
            href="#subscribe"
            className="inline-flex shrink-0 items-center whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
          >
            订阅下期榜单
            <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}